module.exports = __webpack_public_path__ + "media/images/workshops-1a1f2158118e7d5c4010e8716b142983.jpeg";